import React, { Fragment } from 'react';
import '../../css/components/vehicleFilters/listFilter.css';

const BrandFilter = ({
    filterTitle,
    itemList,
    filterName,
    filters,
    selectFilter,
    showImages,
    isMultiSelect,
}) => {
    const getCloseButton = (itemId, filterId) => {
        if (
            filters[filterId] != null &&
            filters[filterId].indexOf(itemId) == -1
        )
            return null;
        return (
            <i className="c-icon c-icon--small c-icon--[semantic-close] filter-list-brands__brand-close"></i>
        );
    };

    const renderList = () => {
        if (itemList != undefined && itemList.length > 0) {
            let printList = [];
            let onlyActive = false;
            if (filters[filterName] != null && filters[filterName].length > 0)
                onlyActive = true;

            itemList.map((item, index) => {
                if (
                    !onlyActive ||
                    (onlyActive && filters[filterName].indexOf(item.Id) > -1)
                ) {
                    printList.push(
                        <li
                            id={'idbrand_' + item.Id}
                            brand={item.Id}
                            key={index}
                        >
                            <button
                                className={
                                    'filter-list-brands__brand ' +
                                    (filters[filterName] != null &&
                                    filters[filterName].indexOf(item.Id) > -1
                                        ? 'active'
                                        : '')
                                }
                                name={filterName}
                                onClick={e =>
                                    selectFilter(
                                        e.currentTarget.name,
                                        item.Id,
                                        isMultiSelect
                                    )
                                }
                            >
                                {showImages && (
                                    <img
                                        className="filter-list-brands__brand-image"
                                        alt={`${item.Id}icon`}
                                        src={
                                            process.env.PUBLIC_URL +
                                            '/Bronson/img/' +
                                            item.Description.replace(
                                                / +/g,
                                                ''
                                            ).toLowerCase() +
                                            '-320x320px.png'
                                        }
                                    />
                                )}
                                <span className="filter-list-brands__brand-name u-text-fs-1">
                                    {item.Description}
                                </span>
                                {getCloseButton(item.Id, filterName)}
                            </button>
                        </li>
                    );
                }
            });

            return (
                <ul
                    className="filter-list-brands"
                    aria-label="brandsFilterList"
                    data-testid="brandsFilterList"
                >
                    {printList}
                </ul>
            );
        }
    };

    return (
        <Fragment>
            <div className="c-accordion__header  js-accordion__title c-vehicle-filters__item-title">
                <span className="c-accordion__title-icon"></span>
                <h3 className="c-accordion__title">
                    <button
                        className="c-accordion__title-label  js-accordion__title-label"
                        aria-expanded="true"
                        type="button"
                    >
                        <span className="c-accordion__title-label-text ">
                            {filterTitle}
                        </span>
                    </button>
                </h3>
            </div>
            <div
                className="c-accordion__panel  js-accordion__panel c-vehicle-filters__item-content"
                aria-hidden="true"
            >
                <div className="c-accordion__content c-vehicle-filters__filter-brand">
                    {renderList()}
                </div>
            </div>
        </Fragment>
    );
};

export default BrandFilter;
